export class UserData {
  tuesday: any;
  monday: any;
  wednesday: any;
  thursday: any;
  friday: any;
  saturday: any;
  sunday: any;
  resume: any;
  photoId: any;
  addressProof: any;
  educationalCerts: any;
  experienceLetters: any;
  otherDocs: any;
  employeeIdCard: any;
  employeeExperienceCertificate: any;
  cbseEmployeeForm: any;
  appreciationCertificateEmployee: any;
  position: any;
  name: any;
  firstName: any;
  lastName: any;
  qac: any;
  status: any;
  type: any;
  action: any;
  logo: any;
  bannerImages: any;
  _id: any;
  scheduleId: any;
  lectureSchedule: any;
  scheduleName: any;
  fromDate: any;
  toDate: any;
  mobile: any;
  password: any;
  entity: any;
  userType: any;
  entityType: any;
  permissions: any;
  lastLoginAt: any;
  createdAt: any;
  updatedAt: any;
  token: any;
  entityName: any;
  principal: any;
  location: any;
  settlementDate: any;
  isSettled: any;

  board: any;
  foundingYear: any;
  schoolMedium: any;
  website: any;
  receptionNumber: any;
  contactEmail: any;
  socialMedia: any;
  facilities: any;
  subEntities: any;
  gallary: string;
  contactPerson: any;

  description: any;
  code: any;
  sequenceNo: any;
  groupName: any;
  sessions: any;
  session: any;
  id: any;
  feeHead: any;
  category: any;
  course: any;
  oldNew: any;
  installments: any;
  intallment: any;
  structure: any;
  amount: any;
  stream: any;
  streams: any;
  issueNumber: any;
  subscriptionType: any;
  digitalAccessUrl: any;
  paymentStatus: any;
  branch: any;
  streamSeats: any;
  batch: any;
  batches: any;
  section: any;
  facebook: any;
  google: any;
  twitter: any;
  instagram: any;
  regNo: any;
  fatherName: any;
  motherName: any;
  dob: any;
  rollNo: any;
  studentDemand: any;
  terms: any;
  termGroup: any;
  studentId: any;
  studentConcession: any;
  feeStructure: any;
  concessionStructure: any;
  demand: any;
  assigneeType: any;
  utilities: { name: string; url: string }[];
  dueDemand: any;
  receiptCount: any;
  receiptPrefix: any;
  receiptId: any;
  concessionId: any;
  studentRegNo: any;
  date: any;
  totalPaidAmount: any;
  receipt: any;
  displayName: any;
  rcNo: any;
  totalSeats: any;
  seatingCapacity: any;
  pollutionEndDate: any;
  companyName: any;
  startDate: any;
  endDate: any;
  premiumAmount: any;
  insurance: any;
  pollutionCertificate: any;
  fitnessCertificate: any;
  roadPermit: any;
  roadTax: any;
  receiptFile: any;
  pickUpPoints: any;
  vehicle: any;
  pickUpPoint: any;
  vehicleRoute: any;
  vehicleRoutes: any;
  colourTheme: any;
  value: any;
  missingAttendance: any;
  myDate: any;
  invoiceDueDate: any;
  invoicePerson: any;
  dateRange: any;
  dates: any;
  dayType: any;
  attendanceValue: any;
  paymentDetails: any;
  student: any;
  totalPaybleAmount: any;
  pickedTerms: any;
  entityGroup: any;
  activeSession: any;
  entityPreferences: any;
  entityModules: any;
  totalRegistrations: any;
  todayRegistrations: any;
  asOnRegistrations: any;
  totalAdmissions: any;
  asOnAdmissions: any;
  todayAdmissions: any;
  registrations: any;
  admissions: any;
  updatedAdmission: any;
  eventType: any;
  message: any;
  total: any;
  added: any;
  skipped: any;
  totalRegistratins: any;
  gender: any;
  bloodGroup: any;
  doa: any;
  fatherMobile: any;
  fatherQualification: any;
  fatherOccupation: any;
  motherMobile: any;
  motherQualification: any;
  motherOccupation: any;
  lastSchool: any;
  height: any;
  weight: any;
  religion: any;
  motherTongue: any;
  uid: any;
  srn: any;
  house: any;
  address: any;
  city: any;
  state: any;
  country: any;
  countryCode: any;
  phoneCountryCode: any;
  fatherMobileCountryCode: any;
  motherMobileCountryCode: any;
  guardianMobileCountryCode: any;
  phone: any;
  courseData: any;
  remark: any;
  data: any;
  sessionData: any;
  label: any;
  totalStudents: any;
  count: any;
  dailyFeeData: any;
  monthlyFeeData: any;
  totalPartnerInstitutes: any;
  registrationData: any;
  admissionData: any;
  companyType: any;
  visitType: any;
  partnerName: any;
  visitConclusion: any;
  representative: any;
  companyRepresentative: any;
  eligibleCourse: any;
  totalAppeared: any;
  driveType: any;
  venue: any;
  studentData: any;
  assessmentModel: any;
  subjects: any;
  subjectName: any;
  currentSessionCategory: any;
  suggestedCategory1: any;
  suggestedCategory2: any;
  entityCountCategory: any;
  industry: any;
  fieldOfSpecialisation: any;
  fileType: any;
  folder: any;
  formulae: any;
  specialisation: any;
  resourcePerson: any;
  topics: any;
  area: any;
  associationType: any;
  associatedWith: any;
  applicationNumber: any;
  txnReceipt: any;
  autoRegNo: any;
  placementType: any;
  urls: any;
  titleLogo: any;
  copyrightName: any;
  urlName: any;
  displayDescription: any;
  displayLogo: any;
  loadingLogo: any;
  tncUrl: any;
  privacyPolicyUrl: any;
  disclaimerUrl: any;
  titleName: any;
  newName: any;
  totalAttended: any;
  seminars: any;
  resourcePersonId: any;
  designation: any;
  email: any;
  experience: any;
  classTeacher: any;
  ctEmployeeId: any;
  classTeacherName: any;
  attendanceSubjects: any;
  entityData: any;
  employeeId: any;
  employeeType: any;
  loginAccess: any;
  memberType: any;
  issueType: any;
  bookLimit: any;
  daysLimit: any;
  courses: any;
  prefix: any;
  suffix: any;
  number: any;
  placementData: any;
  totalResourcePerson: any;
  totalSeminars: any;
  totalPartnerCompanies: any;
  entityDisplayName: any;
  desc: any;
  bookshelves: any;
  availability: any;
  subCategory: any;
  updated: any;
  students: any;
  copies: any;
  accession: any;
  title: any;
  localLanguageTitle: any;
  localLanguagePublisher: any;
  localLanguageAuthor: any;
  tags: any;
  miscellaneousRemark: any;
  books: any;
  totalEvents: any;
  partnerInstituteType: any;
  receiverId: any;
  returnStatus: any;
  stages: any;
  sequence: any;
  stage: any;
  txnRequired: any;
  paymentMapping: any;
  txnMapping: any;
  fields: any;
  currentStage: any;
  autoApplicationNumber: any;
  paymentMode: any;
  refId: any;
  bankNane: any;
  transactions: any;
  yearOfPassing: any;
  yearOfAdmission: any;
  employmentType: any;
  presentEmployer: any;
  workAddress: any;
  address1: String;
  address2: String;
  residentialAddress: any;
  alumniMeets: any;
  driveStages: any;
  contributionToInstitute: any;
  feedBack: any;
  sessionId: any;
  courseId: any;
  superSession: any;
  sessionList: any;
  eventGroup: any;
  studentDetails: any;
  bookLanguage: any;
  contactPersonName: any;
  contactPersonMobile: any;
  gst: any;
  pan: any;
  allApplicationNumber: any;
  department: any;
  isHOD: any;
  receiverName: any;
  totalWithdrawals: any;
  termName: any;
  applicationId: any;
  smsConfig: any;
  apiKey: any;
  senderId: any;
  sendTo: any;
  content: any;
  mobileNo: any;
  sendToNumbers: any;
  smsSetup: any;
  classificationNumber: any;
  communicationSetup: any;
  applyFine: any;
  fineAmount: any;
  upToAmount: any;
  onEveryDays: any;
  pageSequence: any;
  publishingYear: any;
  issuedBooks: any;
  overDueBooks: any;
  totalBooks: any;
  otherIncomeHead: any;
  subjectConfig: any;
  assessment: any;
  incomeDetails: any;
  assessmentName: any;
  preFilledSeats: any;
  feedBackParameter: any;
  codeNo: any;
  photo: any;
  assessments: any;
  allRegNo: any;
  feeReceipt: any;
  refundReceipt: any;
  bookNo: any;
  invoiceDate: any;
  courseGroup: any;
  newspaperDays: any;
  serialType: any;
  subscriptionNo: any;
  frequency: any;
  subscriptionLength: any;
  issn: any;
  firstArrivalDate: any;
  subscriptionCost: any;
  costPerCollection: any;
  vendor: any;
  expectedCopies: any;
  expectedCost: any;
  receivedNow: any;
  skippedArr: any;
  subject: any;
  channel: any;
  isDefault: any;
  homework: any;
  employeeAssignment: any;
  employeeHomework: any;
  employeeCircular: any;
  employeeNotice: any;
  employeeSyllabus: any;
  employeeDateSheet: any;
  employeeELearning: any;
  employeeTimeTable: any;
  gatePass: any;
  visitor: any;
  library: any;
  admissionReminder: any;
  admissionTransaction: any;
  admission: any;
  attendance: any;
  registration: any;
  birthday: any;
  transaction: any;
  dueFee: any;
  collectionStatus: any;
  actualCost: any;
  receivedDate: any;
  publishedDate: any;
  edition: any;
  receivedCopies: any;
  subscription: any;
  invoice: any;
  publisher: any;
  editor: any;
  bankName: any;
  bookShelf: any;
  bookRack: any;
  isbn: any;
  cost: any;
  pages: any;
  author: any;
  publishDate: any;
  mis: any;
  admissionHead: any;
  skippedArray: any
  skippedReceiptCount: any;
  skippedCount: any;
  addedCount: any;
  gradeConfig: any;
  admissionStudentData: any;
  addedStudentFlag: any;
  employmentProfile: any;
  organisedBy: any;
  nationality: any;
  maritalStatus: any;
  joiningDate: any;
  epf: any;
  esi: any;
  qualification: any;
  gradeSetup: any;
  entryType: any;
  feeHeads: any;
  dueAmountPercent: any;
  concessionGroupName: any;
  academicResult: any;
  includeInTotal: any;
  concession: any;
  counselorId: any;
  counselorName: any;
  followUpDate: any;
  promotedStatus: any;
  dueAmount: any;
  DLT_TE_ID: any;
  toggleStatusData: any;
  inactiveRemark: any;
  inactiveTime: any;
  inactiveUserMobile: any;
  inactiveUserName: any;
  received: any;
  payable: any;
  extraFee: any;
  dues: any;
  toMeetType: any;
  toMeet: any;
  staffName: any;
  approvedBy: any;
  fromTime: any;
  toTime: any;
  reason: any;
  purpose: any;
  seekerType: any;
  organizationName: any;
  takerName: any;
  takerMobile: any;
  takerRelation: any;
  userName: any;
  userMobile: any;
  notificationType: any;
  notificationMsg: any;
  notificationDate: any;
  redirectUrl: any;
  redirectUrlName: any;
  readBy: any;
  bankAccount: any;
  approvedById: any;
  seekerId: any;
  toMeetId: any;
  sendSMS: any;
  url: any;
  attachURL: any;
  urlFields: any;
  entryDate: any;
  entityId: any;
  lastEntryDate: any;
  file1: any;
  file2: any;
  submissionDate: any;
  emailConfig: any;
  sendEmail: any;
  emailSetup: any;
  emailSubject: any;
  htmlBody: any;
  htmlBodyChange: any;
  source: any;
  sourceGroup: any;
  counselorUpdate: any;
  counselorEmail: any;
  counselorMobile: any;
  tcNumber: any;
  higherStudies1: any;
  higherStudies2: any;
  communicationPreference: any;
  presentStatus: any;
  courseName: any;
  universityName: any;
  specialAchievements: any;
  seats: any;
  checkSeats: any;
  permissionGroup: any;
  permissionGroupId: any;
  permissionGroupName: any;
  verifiedDocuments: any;
  isLEET: any;
  branchName: any;
  accountNumber: any;
  ifscCode: any;
  studentName: any;
  transactionData: any;
  voucherType: any;
  ledger: any;
  otherTransactions: any;
  feeTransactions: any;
  admissionTransactions: any;
  totalAmount: any;
  ledgerData: any;
  studentIds: any;
  subjectType: any;
  studentRollNo: any;
  msTeamsConfig: any;
  msTeamsSetup: UserData;
  edited: boolean;
  editRemark: any;
  branchId: any;
  setup: any;
  headMapper: any;
  bankAccountMapper: any;
  accessKey: any;
  companyId: any;
  secretKey: any;
  courseSegmentMapper: any;
  ledgerDetails: any;
  partialAmount: any;
  partialPayment: any;
  feeAmount: any;
  subjectData: any;
  subjectCombination: any;
  sectionSelect: any;
  subjectCombinationName: any;
  totalMarks: any;
  percentage: any;
  grade: any;
  totalWeightage: any;
  weightage: any;
  groups: any;
  studentCount: number;
  totalAbsent: number;
  totalDays: number;
  totalHoliday: number;
  totalLeave: number;
  totalNotMarked: number;
  totalPresent: number;
  totalWorking: any;
  appendedName: any;
  tempRegNo: any;
  parent: any;
  metaData: {};
  bookIssueType: any;
  memberId: any;
  publishingPlace: any;
  membershipStartDate: any;
  membershipEndDate: any;
  employeeName: any;
  employee: any;
  inTime: string;
  outTime: string;
  regNoNameSort: any;
  payroll: any;
  segmentId: any;
  returnDays: any;
  autoAccession: any;
  autoVoucher: any;
  resultDeclared: any;
  displayValue: boolean;
  scholastic: any;
  scholasticHeads: any;
  scholasticTableHeads: any;
  studentLedgerMaster: any;
  studentLedgerGroupMaster: any;
  assessmentTotal: any[];
  deletedCount: string;
  editResult: any;
  dueFeeData: any;
  apiStatus: any;
  available: any;
  approvedDoc: any;
  fileType1: string;
  fileType2: string;
  defaultTimeTable: any;
  group: any;
  frozen: boolean;
  goToMapping: any;
  subjectCode: any;
  lectDetail: { startTime: any; endTime: any; sequence: any; name: any; };
  ledgerCode: any;
  dateCount: any;
  lastDate: any;
  tableHead: any[];
  feeHeadsData: any;
  feeHeadsDataConcession: any;
  currentDate: any;
  marksConfig: any;
  marks: any;
  dashboard: any;
  analytics: any;
  quickLinks: any;
  calendar: any;
  fee: any;
  overview: any;
  profile: any;
  totalEmployees: any;
  dailyEnquiries: any;
  studentsWithBooks: any;
  dailyAdmissions: any;
  totalPendingEnquiries: any;
  lectureData: any;
  sections: any;
  dailyCount: any;
  dailyTotalPaidAmount: any;
  monthlyCount: any;
  monthlyTotalPaidAmount: any;
  cancelVoucherDate: any;
  statusRemarks: any;
  statusRemark: any;
  partnerInstituteName: any;
  leaveDate: any;
  file: any;
  otherIncomeMapperData: any;
  otherIncomeSegmentMapper: any;
  roomType: any;
  hostel: any[];
  bed: any;
  roomCharges: any;
  beds: any;
  roomName: any;
  bedName: any;
  hostelRoomType: any;
  hostelRoomId: any;
  hostelRoomName: any;
  hostelRoomBedName: any;
  leaveStartDate: string | number | Date;
  leaveEndDate: string | number | Date;
  dormantStudents: any;
  appStudents: any;
  htmlData: any;
  htmlDataChange: any;
  report: any;
  printReceiptCount: any;
  selectedName: any;
  termGroupName: any;
  remarks: any;
  results: any;
  studentAttendance: any;
  working: any;
  workingDays: any;
  presentDays: any;
  present: any;
  originalPayable: any;
  feedbackType: any;
  feedbackCategory: any;
  attachment: any;
  studentDetailsId: any;
  lockAfterSubmission: boolean;
  assignmentId: any;
  privacy: string;
  courseSelected: any;
  facebookToggle: any;
  instagramToggle: any;
  linkdinToggle: any;
  whatsappToggle: any;
  twitterToggle: any;
  youtubeToggle: any;
  contentType: any;
  totalFilled: number;
  seatsLeft: number;
  obtainedMarks: any;
  inactiveStudents: any;
  holiday: any;
  leave: any;
  salaryCycle: any;
  salaryType: any;
  shiftMaster: any;
  socialCategory: any;
  shift: any;
  hrmShift: any;
  shiftSource: any;
  hrmHoliday: any;

  confirmDate: any;
  noticeDate: any;
  terminationDate: any;
  payGradeApplicableDate: any;
  seekerCode: any;
  remarkList: any;
  incorrectMobileStudents: any;
  courseDataName: { course: any; stream: any; batch: any; };
  accountName: any;
  birthDayStudents: any;
  groupByCourse: any;
  groupByReligion: any;
  groupBySocialCategory: any;
  headCount: any;
  admissionCount: any;
  enquiriesByCourse: any;
  enquiriesBySource: any;
  admissionCounts: any;
  dailyPaymentDetails: any;
  estimatedCollections: any;
  monthlyPaymentDetails: any;
  studentHeadCount: any;
  booksCirculated: any;
  booksCount: any;
  groupByMemberType: any;
  groupByMemberTypeUnique: any;
  todayBooksCount: any;
  top10Books: any;
  top10OverDueDefaulters: any;
  groupByCourseSubject: any;
  groupByEmployeeType: any;
  groupByDepartment: any;
  birthdayEmployees: any;
  totalDueAmount: any;
  skipInstallments: any;
  dropAmount: any;
  pickUpTransport: any;
  pickUpTransportdropTransport: any;
  vehicleRouteDropPoint: any;
  dropPoint: any;
  pickTime: any;
  dropTime: any;
  dropTransport: any;
  siblings: any;
  whatsAppWebConfig: any;
  whatsAppWebSetup: UserData;
  paymentFrequency: any[];
  hostelPaymentFrequency: any
  hostelEndDate: any;
  hostelStartDate: any;
  awakeStatus: any;
  ageAtAdmission: string;
  entityDisplayLogo: any;
  sendWhatsAppWeb: any;
  whatsAppWebTemplate: any;
  coordinator: any;
  coordinatorId: any;
  coordinatorName: any;
  files: any;
  feeHeadGroups: any;
  updatedCount: string;
  availableSeats: number;
  filledSeats: number;
  pendingApplications: number;
  receiptHeads: any;
  secondaryEducation: any;
  pin: any;
  ifsc: any;
  pay: any;
  payGrade: any
  paymentMethod: any;
  pinCode: any;
  isMetro: any;
  highestAcademicQualification: any;
  highestProfessionalQualification: any;
  appointedForSubject: any;
  mainSubjectTaught: any;
  additionalSubjectTaught: any;
  mathsScienceStudiedUpto: any;
  englishStudiedUpto: any;
  socialStudiesStudiedUpto: any;
  computerTrained: any;
  cwsnTrained: any;
  evaluationMedium: any;
  classesTaught: any;
  wardAppearingInClass10: any;
  wardAppearingInClass12: any;
  seniorSecondaryEducation: any;
  trained: any;
  qualified: any;
  trainingCoursesAttended: any;
  nepSubjectType: any;
  mdcName: any;
  mdcCode: any;
  aecName: any;
  aecCode: any;
  secName: any;
  secCode: any;
  vacName: any;
  vacCode: any;
  purchasePrice: any
  attendanceDevideId: any;
  oldAutoVoucher: any;
  newAutoVoucher: any;
  toEntity: any;
  toSession: any;
  toStage: string;
  toSessionEndDate: any;
  toEntityQAC: any;
  bankDetails: {
    bankName: '',
    branchName: '',
    accountNumber: '',
    ifscCode: '',
    studentName: ''
  };
  moderator: any;
  studentClubs: any
  inLogDate: any;
  formattedTime: string;
  gradeRemark: any;
  passingMarks: any;
  authorName: any;
  showGraph: boolean;
  holidays: any;
  leaveTypes: any;
  leaveCycleName: any;
  calendarData: any;
  presentPercentage: string;
  absentPercentage: string;
  leavePercentage: string;
  totalWeeklyOff: number;
  comments: any;
  assignedTo: any;
  assignedToName: any;
  assignedToMobile: any;
  assignedByName: string;
  assignedByMobile: string;
  assignedBy: any;
  attendanceDeviceId: any;

  courseMapperData: any
  courseTags: any;
  subjectTags: any[];
  chapterName: any;
  topicName: any;
  questionText: any;
  difficultyLevel: any;
  answerType: any;
  dueDate: string;
  priority: string;
  refund: any;
  examType: any;
  bookId: any;
  viewName: any;
  filterValues: any;
  tableHeads: any[];
  previousVersions: any;
  sortOrder: any;
  sortBy: any;
  criteria: any[];
  leaveList: any;
  taskList: any;
  arType: any;
  approver: null;
  approverId: null;
  approverName: null;
  approver1: any;
  approverId1: any;
  approverName1: any;
  approver2: any;
  approverId2: any;
  approverName2: any;
  leaveCount: any;
  dueTask: any;
  arCount: any;
  odCount: any;
  attendanceCount: any;
  createODPayEntity: boolean;
  aadhaarCardBack: any;
  aadhaarCardFront: any;
  panCard: any;
  metricCertificate: any;
  passingCertificate12th: any;
  qualificationCertificates: any;
  highestAcademicQualificationCertificates: any;
  highestProfessionalQualificationCertificates: any;
  passbook: any;
  leaveManager1: any;
  leaveManagerId1: any;
  leaveManagerName1: any;
  leaveManager2: any;
  leaveManagerId2: any;
  leaveManagerName2: any;
  arManager1: any;
  arManagerId1: any;
  arManagerName1: any;
  arManager2: any;
  arManagerId2: any;
  arManagerName2: any;
  paymentDueAlert: any;
  enableHalfDay: any;
  sessionEndDate: any;
  earningHeads: any;
  deductionHeads: any;
  employerContributionHeads: any;
  alternateTimingDays: any;
  alternateMinWorkingHours: any;
  alternateQuarterOutTime: any;
  alternateQuarterInTime: any;
  alternateHalfTime: any;
  alternateEndTime: any;
  alternateStartTime: any;
  leaveStatus: any;
  studentList: any;
  selectedStudentObj: any;
  autoEmployeeId: boolean;
  lecturesRequired: any;
  dobInWords: any;
  leaveGroupMaster: any;
  refundType: string;
  appNotificationSetup: UserData;
  allowNoDues: boolean;
  pendingODPayTransactionCount: any;
  pendingVoucherAPIStatusCount: any;
  pendingVoucherCreationCount: any;
  sort: any;

  timeline: any;
  counselor: any;
  admissionSource: any;
  counselorMapper: any;
  stageCounselor: any;
  duplicacyCheckFields: any;
  stageCounselorEmail: any;
  stageCounselorId: any;
  stageCounselorName: any;
  stageCounselorMobile: any;
  time: any;
  completionRemark: any;
  followUpQuery: any
  testDate: any;
  callDetails: any;
  whatsAppConfig: any;
  whatsAppSetup: UserData;
  whatsAppParameterValues: any;
  hostelWarden: any;
  hostelWardenId: any;
  hostelWardenName: any;
  sendWhatsApp: any;
  myOperatorKeys: any;
  role: any = [];
  tagSourceDocs: UserData[];
  notesCount: any;
  totalFollowUp: any;
  totalActivity: any;
  totalCount: any;
  engagedCount: any;
  notEngagedCount: any;
  overDueFollowUp: any;
  completeFollowUp: any;
  totalActivityCount: any;
  untouchedCount: any;
  totalLeadCount: any;
  totalApplicationCount: any;
  userDetails: any;

  cancellationRemark: any;


 
  hostelWardens: any;

  qualifications: any = [];
  workExperience: any = [];
  flag: any;
  hrmLeaveCycleTeachingMonths: any;
  teachingMonths: any;
  salaryComputed: any;
  punchInCount: any;
  vehicleRouteId: any;
  correspondenceCountry: any;
  correspondenceState: any;
  correspondenceDistrict: any;
  district: any;
  defaultPaymentMode: any;
  cash: boolean;
  bankTransfer: boolean;
  bankLoan: boolean;
  cardPOS: boolean;
  cheque: boolean;
  demandDraft: boolean;
  online: boolean;
  staticUpiQr: boolean;
  feeExtensionDate: any;
  feeExtensionStartDate: any;
  feeExtensionRemark: any;
  studentBankDetails: any;
  chequeDate: any;
  awakeDormantCount: any;
  inactiveReason: any;
  partnerCategory: any[];

  roles: any;
  permission: any;
  result: any;
  reportCard: any;
  employees: any;
  dropRoute: any;
  pickUpRoute: any;
  pickUpTime: any;
  laCount: any;
  unresolvedODPayQueries: any;
  correspondencePinCode: any;
  correspondenceCity: any;
  correspondenceAddress: any;
  workLocation: any;
  buttonLabel: any;
  buttonRedirectURL: any;
  photoThumbnail: string;
  gatePassCategory: any;
  yearOfJoiningService: any;
  stageType: string;
  reference1: string;
  reference2: string;
  receiptRemark: any;
  feeRemark: any;
  savedRemark: boolean;
  createdBy: string;
  createdByMobile: string;
  createdByName: string;
  halfTime: any;
  endTime: any;
  startTime: any;
  attachPDF: any;
  pdfTemplate: any;
  extraFeeOpening: any;
  demandArr: any;
  feeHeadGroupArr: any[];
  extraFeeRemark: any;
  creditValue: any;
  totalReceived: any;
  officialRemark: any;
  visit: any;
  attendanceData: any;
  startTimeGracePeriod: any;
  expectedReturnDate: any;
  dueDays: number;
  subTitle: any;
  totalEmployee: any;
  totalHalfDay: any;
  totalLWP: any;
  noticeAndLetter: any;
  participationStudentList: any;
  activityDetailedReport: any;
  geoTaggedPhotos: any;
  feedbackForm: any;
  feedbackAnalysis: any;
  newsClipsDetail: any;
  certificates: any;
  noticeAndLetterValue: any;
  participationStudentListValue: any;
  activityDetailedReportValue: any;
  geoTaggedPhotosValue: any;
  feedbackFormValue: any;
  feedbackAnalysisValue: any;
  newsClipsDetailValue: any;
  filesValue: any
  certificatesValue: any;
  categories: any;
  fatherPhoto: any;
  motherPhoto: any;
  guardianPhoto: any;
  inactiveDate: any;
  distributor: any;
  bankAccountGatewayMapper: any;
  instituteName: any;
  author2: any;
  newCourse: any;
  scholasticGrandObtainedTotalWeightageMaxMarks: any;
  scholasticGrandObtainedTotalWeightagePercentage: any;
  scholasticGrandObtainedTotalWeightageMarks: any;
  scholasticGrandObtainedTotalWeightageMarksRoundOff: any;
  scholasticGrandObtainedTotalWeightagePercentageRoundOff: any;
  scholasticGradeConfig: any;
  scholasticGrandGrade: any;
  scholasticGrandGradeRoundOff: any;
  discipline: any;
  disciplineGrandObtainedTotalWeightageMaxMarks: any;
  disciplineGrandObtainedTotalWeightagePercentage: any;
  disciplineGrandObtainedTotalWeightagePercentageRoundOff: any;
  disciplineGradeConfig: any;
  disciplineGrandGrade: any;
  disciplineGrandGradeRoundOff: any;
  disciplineGrandObtainedTotalWeightageMarks: any;
  disciplineGrandObtainedTotalWeightageMarksRoundOff: any;
  coScholastic: any;
  coScholasticGrandObtainedTotalWeightageMaxMarks: any;
  coScholasticGrandObtainedTotalWeightagePercentage: any;
  coScholasticGrandObtainedTotalWeightagePercentageRoundOff: any;
  coScholasticGradeConfig: any;
  coScholasticGrandGrade: any;
  coScholasticGrandGradeRoundOff: any;
  coScholasticGrandObtainedTotalWeightageMarks: any;
  coScholasticGrandObtainedTotalWeightageMarksRoundOff: any;
  oldAttendanceValue: any;
  totalArrear: any;
  totalNetSalary: any;
  salary: any
  templateType: any;
  hostelDetails: any;
  txnData: any;
  lectures: any;
  timings: any;
  avgAttendance: any;
  salaryHeadMapper: any;
  subjectWiseData: any;
  teams: any;
  isDuplicate: any;
  employeeList: any;
  employeeData: any;
  ccEmail: any;
  senderIdEmail: any;
  visitCount: any;
  dateWiseFine: any;
  groupByHodType: any;
  birthdayHods: any;

  punchInEmployees: any;
  dailyLeaveAlert: any;
  dailyARAlert: any;
  chatBotConfig: any;
  module: any;
  actionId: any;
  headerType: any;
  headerText: any;
  headerUrl: any;
  body: any;
  footer: any;
  interactiveType: any;
  buttons: any[];
  list: any[];
  deletedArr: boolean;
  whatsappService: any;
  whatsappUtility: any;
  auth: any;
  sms: any;
  whatsappMarketing: any;
  formUrl: any;
  reportUrl: any;
  formType: any;
  dataMapping: any;
  monthYear: any;
  lock: boolean;
  templateId: any;
  sendToType: string;
  liabilityHead: any[];
  spouseName: any;
  workMobile: any;
  liabilityHeads: any;
  multiplier: any;
  reportData: any
  uan: any
  withoutPayDays: any;
  grossEarning: any;
  pfNotDeductedSalary: any;
  pfDeductedSalary: any;
  pfEmployeeContribution: any;
  txnHead: any;
  receiptIdCounter: UserData;
  libraryReceipt: any;
  examRegistrations: any;
  approveStatus: any;
  issueStatus: any;
  issueRecord: any;

  takerPhoto: any;

  attendanceDoc: any;
  age: string;
  outDate: Date;
  deviceId: string;


  appStatus: any;
  admissionCourse: any;
  punchDataEmployees: any
  organizingCommitteeRole: any[];
  attendedStudentCount: any;
  participationStudentCount: boolean;
  locations: any[];
  paidAmount: any;
  notificationSchoolDiary: any
  resultFlag: any
  attachmentTemplate: any;
  certificateCounter: any;
  certificateNumber: any;
  lateArrival: boolean;
  lateArrivalDeduction: number;
  schoolId: any;
  udiseId: any;
  cbseSchoolCode: any;
  cbseAffiliationNumber: any;
  admissionDataMapper: any;
  admissionDataUrl: any;
  admissionDataIntergration: any;
  freezeIssueBook: any;
  subjectCharges: any;
  directAssignee: any;
  tat: number;
  roleType: any;
  otherIncomeAmountMapper: any;

  refundableHeads: any;
  pageNumber: number;
  pageSize: number;
  questions: any;

  search: any;
  complianceCertificateNames: any;



  major: any;
  majorGrandObtainedTotalWeightageMaxMarks: number;
  majorGrandObtainedTotalWeightagePercentage: string;
  majorGrandObtainedTotalWeightageMarks: any;
  majorGrandObtainedTotalWeightageMarksRoundOff: number;
  majorGrandObtainedTotalWeightagePercentageRoundOff: string;
  majorGradeConfig: any;
  majorGrandGrade: any;
  majorGrandGradeRoundOff: any;
  minor: any;
  minorGrandObtainedTotalWeightageMaxMarks: number;
  minorGrandObtainedTotalWeightagePercentage: string;
  minorGrandObtainedTotalWeightageMarks: number;
  minorGrandObtainedTotalWeightagePercentageRoundOff: string;
  minorGrandObtainedTotalWeightageMarksRoundOff: number;
  minorGradeConfig: any;
  minorGrandGradeRoundOff: any;
  mdc: any;
  mdcGrandObtainedTotalWeightageMaxMarks: number;
  mdcGrandObtainedTotalWeightagePercentage: string;
  mdcGrandObtainedTotalWeightageMarks: any;
  mdcGrandObtainedTotalWeightagePercentageRoundOff: string;
  mdcGrandObtainedTotalWeightageMarksRoundOff: any;
  mdcGradeConfig: any;
  mdcGrandGradeRoundOff: any;
  sec: any;
  secGrandObtainedTotalWeightageMaxMarks: number;
  secGrandObtainedTotalWeightagePercentage: string;
  secGrandObtainedTotalWeightageMarks: any;
  secGrandObtainedTotalWeightagePercentageRoundOff: string;
  secGrandObtainedTotalWeightageMarksRoundOff: any;
  secGradeConfig: any;
  secGrandGradeRoundOff: any;
  vac: any;
  vacGrandObtainedTotalWeightageMaxMarks: number;
  vacGrandObtainedTotalWeightagePercentage: string;
  vacGrandObtainedTotalWeightageMarks: any;
  vacGrandObtainedTotalWeightagePercentageRoundOff: string;
  vacGrandObtainedTotalWeightageMarksRoundOff: any;
  vacGradeConfig: any;
  vacGrandGradeRoundOff: any;
  aec: any;
  aecGrandObtainedTotalWeightageMaxMarks: number;
  aecGrandObtainedTotalWeightagePercentage: string;
  aecGrandObtainedTotalWeightageMarks: any;
  aecGrandObtainedTotalWeightagePercentageRoundOff: string;
  aecGrandObtainedTotalWeightageMarksRoundOff: any;
  aecGradeConfig: any;
  aecGrandGradeRoundOff: any;
  readStatus: any;
  extraFeeCarriedNextSession: any;
  imgUrl: any;






  fuelTankCapacity: any;
  mode: any;
  subjectMode: any;
  fieldOfStudy: any;
  alternativeRequired: boolean;
  passingRequired: boolean;
  alternativeEmployees: any;



  blockOnlinePayments: any;
  fineWaiveOff: any;
  voc: any;
  vocGrandObtainedTotalWeightagePercentage: string;
  vocGrandObtainedTotalWeightageMarks: any;
  vocGrandObtainedTotalWeightageMaxMarks: any;
  vocGrandObtainedTotalWeightagePercentageRoundOff: string;
  vocGrandObtainedTotalWeightageMarksRoundOff: any;
  vocGradeConfig: any;
  vocGrandGradeRoundOff: any;
  foodType: any;
  sessionWiseCount: any;
  override: boolean;
  cancelledByUserMobile: any;
  cancelledByUserName: any;
  docs: any;
  errs: any;
  oldDepartment: any;
  newDepartment: any;
  oldDesignation: any;
  newDesignation: any;
  effectiveDate: any;
  oldSalary: any;
  newSalary: any;

  deleteRequestId: any;
  otp1: any;

  urlForms: any;
  pdfForms: any;
  fileUrl: any;
  otp2: any;
  corrCity: any;
  corrAddress: any;
  corrCountry: any;
  corrPinCode: any;
  transportStartDate: Date;
  transportEndDate: Date;
  entityAPIResponse: any;
  erpReceiptNo: any;
  fineWaveOffRemark: any;
  separateArrearPayoutSalaryHead: boolean;
  bookName: string;
  halfDayRemark: any;
  weekend: string[];
  resignationDoc: any;
  millersPyramid: any;
  bloomsTaxonomy: any;
  attendanceShortageLetter: boolean;
  typeOfBook: string;
  level: string;
  publicationType: any;
  dateOfPublication: any;
  conferenceName: any;
  proceedingTitle: any;
  yearOfPublication: any;
  affiliatingInstitute: any;
  publisherName: any;
  coAuthors: any;
  minimumAge: any;
  asOnDate: any;

  excludeArrearFromSalary: boolean;
  tutionFeeHeadGroup: any;
  visibilityStatus: boolean;
  
  rank: number;
  totalScholasticObtainedMarks: any;
  signatureUrl: any;
  demandAmount: any;
  maxPay: any;
  installment: any;
  smsTemplate: null;
  whatsAppTemplate: null;
  emailTemplate: null;
  availabilityUpdatedAt: any;
  yearOfJoiningPresentInstitute: number;
  selectedTeacher: string;
  selectedCoordinators: any[];
  teacherOptions: { filterOptions: string[]; placeholder: string; optionValue: any; };
  coordinatorOptions: { optionList: string[]; placeholder: string; optionValue: any; };
  filteredTeacherList: any[];
  filteredCoordinatorList: any[]; 
  filteredGroupList: any[];
  tuitionFeeHeadGroups: any;
  signature: any;
  tenthCertificate: any;
  twelfthCertificate: any;
  diplomaCertificate: any;
  graduationCertificate: any;
  postGraduationCertificate: any;
  phdCertificate: any;
  bedCertificate: any;
  netCertificate: any;
  resignationDocument: any;
  servicePeriod: any;
  mCubeKeys: UserData;
  presentByDefault: any;
  voucherPostingPlatform: string;
  submissionCategory: any;
  authors: any[];
  internalAuthors: any;
  externalAuthors: any;
  reportType: string;
  gpsId: any;
  totalIncentive: any;
  attendanceRemarks: any;
  selectedTeacherOptions: any[];
  selectedCoordinatorOptions: any;
  todayFollowUpDone: any;
	appEmployees: any;
  originalAttendance: any;
  studentSearchData: any;
  hrmShiftName: any;
  hrmLeaveGroup: any;
  cancellationCheckBounceDate: any;
  segments: any[];
	enquiriesByCourseAndStream: any;
  reEvaluationTransaction: any;
  examDetail: any;
  used: UserData;
  totalPayableAmount: any;
  publishingStartDate: any;
  publishingEndDate: any;
  volume: any;
  dateOfReceipt: any;
  orderNo: any;
  alumni: any;
  promoteDemandSource: any;
}
